import type { TableData, TableProps } from '@repo/sds/components/SDSTable/types/table.types';

export type ResolvedTableProps<T extends TableData> = Omit<
  TableProps<T>,
  | 'sortable'
  | 'filterable'
  | 'virtualized'
  | 'rowHeight'
  | 'paginationKey'
  | 'hasMore'
  | 'isLoading'
  | 'selectable'
  | 'getRowId'
  | 'actionsLabel'
> & {
  sortable: boolean;
  filterable: boolean;
  virtualized: boolean;
  rowHeight: number;
  paginationKey: string;
  hasMore: boolean;
  isLoading: boolean;
  selectable: boolean;
  getRowId: (row: T) => string;
  actionsLabel: string;
};

export function resolveTableProps<T extends TableData>(props: TableProps<T>): ResolvedTableProps<T> {
  return {
    ...props,
    sortable: props.sortable ?? true,
    filterable: props.filterable ?? false,
    virtualized: props.virtualized ?? false,
    rowHeight: props.rowHeight ?? 50,
    paginationKey: props.paginationKey ?? 'default',
    hasMore: props.hasMore ?? false,
    isLoading: props.isLoading ?? false,
    selectable: props.selectable ?? false,
    getRowId: props.getRowId ?? (row => row.id),
    actionsLabel: props.actionsLabel ?? 'Actions',
  };
}
